import styled from 'styled-components';

import { nwDropzoneStyles } from '@components/Gui/NwUploadStyles';

export const StyledArticleMediaPreview = styled.div`
    position: relative;
    width: min(100%, 18rem);
    aspect-ratio: 4 / 3;
    background: #f5f5f5;
    border: ${(props) => props.theme.DefaultBorder};
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    margin-bottom: 0.75rem;

    /* da vuoto e' un bersaglio, non un'anteprima: prende tutta la larghezza disponibile
       e resta alto quanto la preview piena, cosi' il blocco non salta quando si carica */
    &.is-empty {
        inline-size: 100%;
        block-size: 13.5rem;
    }

    > button {
        z-index: 5;
    }

    ${nwDropzoneStyles}
`;

// Sostituisce le sorgenti quando un media e' gia' stato scelto: prima va rimosso.
export const ArticleMediaHint = styled.p`
    margin: 0;
    padding: 0.6rem 0.75rem;
    border: ${(props) => props.theme.DefaultBorder};
    border-radius: 4px;
    background: ${(props) => props.theme.SelectedBackgroundColor};
    font-size: ${(props) => props.theme.FontSizeSm};
    color: ${(props) => props.theme.TextColorMuted};
`;
